import { useIntl } from 'react-intl';
import { Row, Col, Form, Switch } from 'antd';
import {
  StyledButton,
  StyledForm,
  StyledFormItem,
} from 'styles/overrides';

import { MultipleUpload } from 'components/upload';
import { serializeFiles } from 'utils/common';

export default function SettingForm({
  onSubmit,
  initialValues,
  isLoading = false,
  typeUpdate = false
}) {
  const intl = useIntl();
  const [form] = Form.useForm();

  const handleSubmit = (values) => {
    let result = null
    if(typeUpdate === 'update') {
      const data = {
        image_id: serializeFiles(values.file),
        action: values?.action ? 1 : 0 
      };
      result = data
    }else {
      const data = {
        ...values,
        image_id: serializeFiles(values.file),
      };
      result = data
    }
    onSubmit?.(result);
  };

  return (
    <StyledForm
      layout="vertical"
      size="large"
      form={form}
      onFinish={handleSubmit}
      initialValues={initialValues}
    >
      <Row gutter={[32, 0]}>
        {!typeUpdate &&
          <>
            <Col span={24}>
              <StyledFormItem
                label={intl.formatMessage({
                  id: 'views.categories.form.label.file',
                })}
                name="file"
                rules={[{ required: true }]}
              >
                <MultipleUpload typeMenu='menu' />
              </StyledFormItem>
            </Col>
          </>
        }

        {typeUpdate &&
          <>
            <Col span={24} sm={12}>
              <StyledFormItem
                label={intl.formatMessage({
                  id: 'common.field.published',
                })}
                name="action"
                valuePropName="checked"
              >
                <Switch />
              </StyledFormItem>
            </Col>

            <Col span={24}>
              <StyledFormItem
                label={intl.formatMessage({
                  id: 'views.categories.form.label.file',
                })}
                name="file"
                rules={[{ required: true }]}
              >
                <MultipleUpload typeMenu='menu' />
              </StyledFormItem>
            </Col>
          </>
        }

        <Col span={24}>
          <StyledFormItem style={{ textAlign: 'center' }}>
            <StyledButton htmlType="submit" type="primary" loading={isLoading}>
              {intl.formatMessage({ id: 'common.btn.save' })}
            </StyledButton>
          </StyledFormItem>
        </Col>
      </Row>
    </StyledForm>
  );
}
